<div class="sem-report-container">

  <div (click)="generate()" [ngClass]="setClasses()"><p>{{translationsService.translate('galis_js_generaterep')}}</p></div>
  <!--input matInput #input type="text" [(ngModel)]="model[bindingProperty]" /> -->
  <sem-date-picker [setDisabled]="true" [form]="form" [ngModel]="getProp(bindingProperty,null)"
    (ngModelChange)="setProp(bindingProperty, $event)" name={{bindingProperty}} date-format="DD/MM/YYYY"
  [templateType]="'calendar_month'" [parentBindingProp]="parentBindingProp" [disabled]="true"></sem-date-picker>

  @if (model[bindingProperty]) {
    <span class="url-generated"></span>
  }

  <p class="binding-prop-name">{{bindingProperty}}</p>
</div>